import type { DossierDocument } from '../types/dossierDocument.types';

const DOSSIER_DOCUMENTS_BY_FILE_ID: Record<string, DossierDocument[]> = {
  'a1000001-0000-4000-8000-000000000001': [
    {
      id: 'doc-001-1',
      fileId: 'a1000001-0000-4000-8000-000000000001',
      name: 'Facture d’achat',
      extension: 'pdf',
      origin: 'imported',
      documentTypeLabel: 'Preuve d’achat',
      uploadDate: '2024-01-16',
      uploaderLabel: 'Marie Dupont',
    },
    {
      id: 'doc-001-2',
      fileId: 'a1000001-0000-4000-8000-000000000001',
      name: 'Photo du produit',
      extension: 'jpg',
      origin: 'imported',
      documentTypeLabel: 'Photo',
      uploadDate: '2024-01-16',
      uploaderLabel: 'Marie Dupont',
    },
    {
      id: 'doc-001-3',
      fileId: 'a1000001-0000-4000-8000-000000000001',
      name: 'Étiquette de retour',
      extension: 'pdf',
      origin: 'generated',
      documentTypeLabel: 'Étiquette transporteur',
      uploadDate: '2024-01-18',
      uploaderLabel: 'Revers.io',
    },
    {
      id: 'doc-001-4',
      fileId: 'a1000001-0000-4000-8000-000000000001',
      name: 'Confirmation de clôture',
      extension: 'pdf',
      origin: 'generated',
      documentTypeLabel: 'Document système',
      uploadDate: '2024-02-20',
      uploaderLabel: 'Revers.io',
    },
  ],
  'a1000002-0000-4000-8000-000000000002': [
    {
      id: 'doc-002-1',
      fileId: 'a1000002-0000-4000-8000-000000000002',
      name: 'Bon de livraison',
      extension: 'pdf',
      origin: 'imported',
      documentTypeLabel: 'Preuve d’achat',
      uploadDate: '2024-01-19',
      uploaderLabel: 'Thomas Bernard',
    },
    {
      id: 'doc-002-2',
      fileId: 'a1000002-0000-4000-8000-000000000002',
      name: 'Photo panne',
      extension: 'png',
      origin: 'imported',
      documentTypeLabel: 'Photo',
      uploadDate: '2024-01-20',
      uploaderLabel: 'Thomas Bernard',
    },
    {
      id: 'doc-002-3',
      fileId: 'a1000002-0000-4000-8000-000000000002',
      name: 'Relance automatique',
      extension: 'pdf',
      origin: 'generated',
      documentTypeLabel: 'Notification',
      uploadDate: '2024-02-10',
      uploaderLabel: 'Revers.io',
    },
  ],
  'a1000003-0000-4000-8000-000000000003': [
    {
      id: 'doc-003-1',
      fileId: 'a1000003-0000-4000-8000-000000000003',
      name: 'Ticket de caisse',
      extension: 'jpg',
      origin: 'imported',
      documentTypeLabel: 'Preuve d’achat',
      uploadDate: '2024-02-02',
      uploaderLabel: 'Sophie Martin',
    },
    {
      id: 'doc-003-2',
      fileId: 'a1000003-0000-4000-8000-000000000003',
      name: 'Bordereau d’expédition',
      extension: 'pdf',
      origin: 'generated',
      documentTypeLabel: 'Étiquette transporteur',
      uploadDate: '2024-02-12',
      uploaderLabel: 'Revers.io',
    },
  ],
};

const DEFAULT_DOCUMENTS: DossierDocument[] = [
  {
    id: 'doc-default-1',
    fileId: 'default',
    name: 'Preuve d’achat',
    extension: 'pdf',
    origin: 'imported',
    documentTypeLabel: 'Preuve d’achat',
    uploadDate: '2024-02-01',
    uploaderLabel: 'Client',
  },
  {
    id: 'doc-default-2',
    fileId: 'default',
    name: 'Étiquette de retour',
    extension: 'pdf',
    origin: 'generated',
    documentTypeLabel: 'Étiquette transporteur',
    uploadDate: '2024-02-03',
    uploaderLabel: 'Revers.io',
  },
  {
    id: 'doc-default-3',
    fileId: 'default',
    name: 'Photo du défaut',
    extension: 'jpg',
    origin: 'imported',
    documentTypeLabel: 'Photo',
    uploadDate: '2024-02-02',
    uploaderLabel: 'Client',
  },
];

export const getDossierDocumentsByFileId = (fileId: string): DossierDocument[] =>
  DOSSIER_DOCUMENTS_BY_FILE_ID[fileId] ??
  DEFAULT_DOCUMENTS.map((document) => ({ ...document, fileId }));
